export default {
    displayOptionCommission: '显示佣金详情',
    displayOptionCommissionLevelV: '显示佣金等级',
    displayOptionCommissionLevelH: '显示等级(竖)',
    searchTitle: '筛选区',
    schoolName:'院校名称',
    schoolNationality: '国家/地区',
    schoolProvince: '省份',
    schoolCity: '城市',
    courseLevel: '课程等级',
    searchContent: '请输入搜索内容',
    group: '集团',
    schoolType: '学校种类',
    contractNationality: '学生国籍',
    commissionConditionsSearch: '佣金条件',
    filter: '筛选',
    displayLevel: '只显示等级',
    displaySummary: '显示概括',
    exportList: '导出列表',
    search: '搜索',
    commissionConditions: '佣金条件',
    agentCommission: '代理佣金',
    agentMktFee: '市场费用',
    agentMktFeeRemark: '市场费用备注',
    agentCommissionRemark: '代理佣金备注',
    agentFollowCommission: '后续佣金',
    agentFollowCommissionRemark: '后续佣金备注',
    agentProgramTW: 'Programmes',
    agentProgramTWDirect: 'Direct',
    agentProgramTWPush: 'Push',
    agentProgramHK: 'Promotion',
    agentProgramHints: 'For UK UG/PG Students, special marketing rate will be offered if 2 or more students enrolled to our UK Universities.',
    dataTotalNumber: '共{totalNumber}条数据  ({totalSchool}所学校)',
    hot: '熱搜',
    new: '最新',
    newDays: '天',
    serialNumber: '序号',
    country: '国家/省份/城市',
    operation: '操作',
    commissionRate: '佣金',
    institutionName: '院校名称',
    searchResultEmpty: '請更改搜寻',
    searchResultSameCountry: '本地学生不能获得佣金，请更改搜寻',
    noPermission: '无权访问， 请联络管理员。 ',
    mpsList: '佣金列表',
    naText: '没有指定',
    recommend: '推荐',
    common: '常见',
    recommendTips: '数据按热门排序',
    commonTips: '数据按申请数量排序',
    otherTips: '数据按学校名称排序',
    commonNoDataTips: '没有常见，可使用推荐',
    remarkMPSTips: '注：实际收益以学校更新政策及实际到帐为准，GEA保留最终解释权。',
    countryTips: "属于中国境外学生：请在筛选器中选择对应国家，或咨询您的BD经理。",
  }